import React from 'react';
import { storiesOf } from '@storybook/react';
import { AutomatedReports } from './AutomatedReports';

storiesOf('Manage Alerts/AutomatedReports', module)
  .add('View', () => (
    <AutomatedReports />
  ));



// WEBPACK FOOTER //
// ./src/components/searchAlerts/AutomatedReports/AutomtatedReports.stories.jsx